export const ProductInformationTestIds = {
  productProductId: 'product_productId',
  productProductType: 'product_productType',
  productApplicationName: 'product_applicationName',
  productProductTypeVersion: 'product_productTypeVersion',
  productProducerId: 'product_producerId',
  productProductShortName: 'product_productShortName',
  productProductVersion: 'product_productVersion',
  productProducerName: 'product_producerName',
  productProductName: 'product_productName',
  productFirmwareVersion: 'product_firmwareVersion',
  productHardwareVersion: 'product_hardwareVersion',
  clock: 'clock'
} as const;
